import { useEffect, useRef, useState  } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Button } from 'react-bootstrap';
import { LazyLoadImage } from "react-lazy-load-image-component";
import { handleSetBackdropLoading } from '../../../../redux/actions/loaders';
import { handleSetOpenCustomSnackbar } from '../../../../redux/actions/snackbar';
import { handleChangeDataShopDetailsPage } from '../../../../redux/actions/pages/shop';
import { handleChangeDataTransferPage } from '../../../../redux/actions/pages/transfer';
import { handleChangeDataSelectBranchPage } from '../../../../redux/actions/pages/shop/selectBranch';
import { BASE_SITE, SHOP_DETAILS, SHOP_BRANCHES_POST } from '../../../../apis'; 
import axios from "axios";
import * as qs from "querystring";
import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/css';
import Coin from '../../../../styles/images/coin.png';
import Phone from '../../../../styles/images/phone-dark.png';
import Location from '../../../../styles/images/location-icon-dark.png';
import {Navigation, Pagination, EffectFade, Autoplay, Scrollbar, A11y} from 'swiper/modules';
import BackIcon from '../../../../styles/images/back-without-bg.png';

const Shop = () => {

    const navigate = useNavigate();
    const { shop } = useParams();
    const dispatch = useDispatch();

    const { token } = useSelector(state => state.user);
    const { content } = useSelector(state => state.shop);
    const { isBackdropLoading } = useSelector(state => state.allLoaders);

    useEffect(() => {
        callApiGetShopDetails();
        // eslint-disable-next-line
    }, [Shop]);


    const titleRef = useRef(null);
    const [isStuck, setIsStuck] = useState(false);
    useEffect(() => {
        const handleScroll = () => {
            const el = titleRef.current;
            if (!el) return;

            const { top } = el.getBoundingClientRect();
            const shouldStick = top <= 0;

            setIsStuck(shouldStick);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);


    const callApiGetShopDetails = () => {
        dispatch(handleSetBackdropLoading(true));

        axios({
            method: 'post',
            url: BASE_SITE + SHOP_DETAILS,
            data: qs.stringify({
                shop,
            }),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': (!!token ? token : '')
            },
        }).then((response) => {
            switch (response.data.status) {
                case 'error':
                    dispatch(handleSetOpenCustomSnackbar(true, {message: response.data.message, severity: 'error', vertical: 'bottom', horizontal: 'center'}));  
                    break;
                case 'ok':
                    dispatch(handleChangeDataShopDetailsPage('content', response.data.content));
                    break;
                default:
                    dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در خروج! لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'bottom', horizontal: 'center'}));  
            }
            dispatch(handleSetBackdropLoading(false));
        }, () => {
            dispatch(handleSetBackdropLoading(false));
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در خروج! لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'bottom', horizontal: 'center'}));  
        });

    };

    const handleBackBtn = () => {
        navigate(-1);
    };


    const handlePayOrBarcode = () => {
        if(content.canTransfer) {
            if(! isBackdropLoading) {
                dispatch(handleSetBackdropLoading(true));

                axios({
                    method: 'post',
                    url: BASE_SITE + SHOP_BRANCHES_POST,
                    data: qs.stringify({
                        shop,
                    }),
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Authorization': (!!token ? token : '')
                    },
                }).then((response) => {
                    switch (response.data.status) {
                        case 'error':
                            dispatch(handleSetOpenCustomSnackbar(true, {message: response.data.message, severity: 'error', vertical: 'bottom', horizontal: 'center'}));  
                            break;
                        case 'ok':
                            const branches = response.data.branches;
                            if(branches.length === 1) {
                                const branch = branches[0];
                                dispatch(handleChangeDataTransferPage('shopId', branch.shopId));
                                dispatch(handleChangeDataTransferPage('branchId', branch.branchId));
                                dispatch(handleChangeDataTransferPage('shopTitle', branch.shopTitle));
                                dispatch(handleChangeDataTransferPage('branchTitle', branch.branchTitle));
                                dispatch(handleChangeDataTransferPage('services', branch.services));
                                if(branch.services.length > 0)
                                    dispatch(handleChangeDataTransferPage('serviceSelected', branch.services[0].service));

                                navigate(`/transfer`);
                            }
                            else if(branches.length > 1) {
                                dispatch(handleChangeDataSelectBranchPage('shop', {id: branches[0].shopId, title: branches[0].shopTitle}));
                                dispatch(handleChangeDataSelectBranchPage('branches', branches));

                                navigate(`/transfer/branch`);
                            }



                            break;
                        default:
                            dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در خروج! لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'bottom', horizontal: 'center'}));  
                    }
                    dispatch(handleSetBackdropLoading(false));
                }, () => {
                    dispatch(handleSetBackdropLoading(false));
                    dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در خروج! لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'bottom', horizontal: 'center'}));  
                });
            }
        }
        else {
            navigate('/barcode_generate');
        }
    };


    return (
        <div id="shop-details-page">

            <Row className="py-3 white-bg sticky top-0 z-index-2 ">
                <Col xs={1} className="d-flex align-items-center"><img src={BackIcon} alt="back" onClick={handleBackBtn} /></Col>
                <Col xs={10} className={`header_h2 ${isStuck ? 'd-block' : 'd-none'}`}>{content.title}</Col>
                <Col xs={1}></Col>
            </Row>

            <Row>
                <div className="w-100">
                    <Swiper 
                            modules={[Navigation, Pagination, Scrollbar, A11y, EffectFade, Autoplay]}
                            slidesPerView={1}
                            pagination={{clickable: true}}
                            autoplay={{delay: 2000, disableOnInteraction: false}}
                            loop={true}
                            navigation >
                    {
                        (content.images !== undefined && content.images.length > 0) ?
                            content.images.map((item, key) => {
                                return (
                                    <SwiperSlide key={key}>
                                        <LazyLoadImage src={item} alt={key} className="w-100" />
                                    </SwiperSlide>
                                );
                            })
                        :''
                    }
                    </Swiper>
                </div>
            </Row>

            <Row className={`mt-3 shop-title ${isStuck ? 'py-2 pl-5' : ''}`} ref={titleRef}>
                <Col className={`header_h2`}>{content.title}</Col>
            </Row>

            <Row className="mt-2">
                <Col dangerouslySetInnerHTML={{ __html: content.description }} className="text-justify" />
            </Row>

            <Row className="my-2">
                {
                    (content.discount_and_pay_methods !== undefined && content.discount_and_pay_methods !== null) ?
                        content.discount_and_pay_methods.split("!#!#").map((item, key) => {
                            return(
                                <Col xs={12} key={key} className="my-1">
                                    <div className="pull-back-info small-txt font-weight-200 d-flex p-1">
                                        <div className="d-flex align-items-center mr-2"><img src={Coin} alt="بازگشت وجه" /></div>
                                        {item}
                                    </div>
                                </Col>
                            );
                        })
                    :''
                }
            </Row>

            <Row className="">
                <Col xs={12} className="header_h4">
                نحوه استفاده
                <ul className="font-size-15 font-weight-300">
                    {
                        (content.how_to_use !== undefined && content.how_to_use !== null) ?
                            content.how_to_use.split("!#!#").map((item, key) => {
                                return(
                                    <li key={key}>{item}</li>
                                );
                            })
                        :''
                    }
                    </ul>
                </Col>
            </Row>


            <div className="d-flex small-txt mt-2">
                <div className="d-flex align-items-center mr-1">
                    <img src={Location} width={20} alt="آدرس" />
                </div>
                <div className="d-flex align-items-center">
                    <div>
                        {content.address} {content.glat !== null && content.glng !== null ? <a className="ml-2 txt-link" href={`http://maps.google.com/maps?daddr=${content.glat},${content.glng}`}>مسیریابی</a> : ''}
                    </div>
                </div>
            </div>

            <div className="d-flex small-txt mt-2">
                <div className="d-flex align-items-center mr-1">
                    <img src={Phone} width={20} alt="شماره تماس" />
                </div>
                <a href={`tel:${content.telephone}`} className="ml-2 txt-link">{content.telephone}</a>
            </div>


            <Row className="mt-4">
                <Col xs={12} className="header_h4">
                    <ul className="font-size-15 font-weight-300 px-4">
                    {
                        (content.more_description !== undefined && content.more_description !== null && content.more_description !== '') ?
                            content.more_description.split("!#!#").map((item, key) => {
                                return(
                                    <li key={key}>{item}</li>
                                );
                            })
                        :''
                    }
                    </ul>
                </Col>
            </Row>

            <div className="w-100 px-3 py-4" style={{position: 'fixed', bottom: '0', right: '0', maxWidth: '650px'}}>
                <Button className={`w-100 custom-vertical-padding login-form-button`} onClick={handlePayOrBarcode} >
                    { content.canTransfer ? 
                        `پرداخت به ${content.title}`
                        :
                        `ایجاد بارکد جهت پرداخت`
                    }
                </Button>
            </div>

        </div>
    );
}

export default Shop;